@if (loading) {
  <div class="mapa-cargando" role="status">
    <mat-progress-spinner
      mode="indeterminate"
      color="primary"
      [diameter]="20"
    ></mat-progress-spinner>
    <span>Cargando servicios…</span>
  </div>
}

<div class="mapa-flotante">
  <app-flotante-servicio-tecnico
    [eventos]="eventos"
    [vehiculosTecnicos]="vehiculosTecnicos"
    [vehiculosPendientesCount]="vehiculosPendientesCount"
    [tecnicos]="tecnicos"
    (tecnicoChange)="onTecnicoSeleccionado($event)"
    (tiposActivosChange)="onTiposActivosChange($event)"
  ></app-flotante-servicio-tecnico>
</div>

<app-mapa-facil-v2
  [center]="[-58.443832, -34.587386]"
  [zoom]="12"
  [style]="tipoMapaBase"
  [mapId]="'MapaServicioTecnicoComponent'"
  [mapasPersonalizados]="mapasPersonalizados"
  [allowedEntityTypes]="allowedTypes"
  [disablePopups]="true"
  (mapReady)="onMapReady($event)"
  (entityClick)="onEntityClick($event)"
></app-mapa-facil-v2>

<!-- Contenido del popup — Mapbox lo mueve a su propio contenedor vía setDOMContent -->
@if (infoPanel) {
  <div id="st-popup-container" style="pointer-events: auto; visibility: hidden">
    <!-- Header -->
    <div class="st-header">
      <div class="st-header-title">
        @switch (infoPanel.tipo) {
          @case ('alarma') {
            <mat-icon class="material-symbols-outlined">doorbell</mat-icon>
          }
          @case ('luminaria') {
            <mat-icon class="material-symbols-outlined">lightbulb</mat-icon>
          }
          @case ('sirena') {
            <mat-icon class="material-symbols-outlined">campaign</mat-icon>
          }
          @case ('vehiculo') {
            <mat-icon class="material-symbols-outlined">
              directions_car
            </mat-icon>
          }
        }
        <span class="st-header-nombre">{{ infoPanel.nombre }}</span>
      </div>
      <button
        irxBotonIcono
        tamano="compacto"
        (click)="cerrarPanel()"
        tooltip="Cerrar"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Info entidad (limitada) -->
    @if (
      infoPanel.cliente ||
      infoPanel.direccion ||
      infoPanel.marcaModelo ||
      infoPanel.patente
    ) {
      <div class="st-entity">
        @if (infoPanel.cliente) {
          <div class="st-row">
            <mat-icon class="material-symbols-outlined st-row-icon">
              business
            </mat-icon>
            <span>{{ infoPanel.cliente }}</span>
          </div>
        }
        @if (infoPanel.direccion) {
          <div class="st-row">
            <mat-icon class="material-symbols-outlined st-row-icon">
              location_on
            </mat-icon>
            <span>{{ infoPanel.direccion }}</span>
          </div>
        }
        @if (infoPanel.patente) {
          <div class="st-row">
            <mat-icon class="material-symbols-outlined st-row-icon">
              pin
            </mat-icon>
            <span>{{ infoPanel.patente }}</span>
          </div>
        }
        @if (infoPanel.marcaModelo) {
          <div class="st-row">
            <mat-icon class="material-symbols-outlined st-row-icon">
              memory
            </mat-icon>
            <span>{{ infoPanel.marcaModelo }}</span>
          </div>
        }
      </div>
    }

    <!-- Servicios técnicos -->
    <div class="st-eventos-header">
      <mat-icon class="material-symbols-outlined">build</mat-icon>
      Servicios técnicos ({{ infoPanel.eventosTecnicos.length }})
    </div>

    <div class="st-eventos">
      @if (infoPanel.eventosTecnicos.length === 0) {
        <div class="st-empty">Sin servicios pendientes</div>
      }
      @for (ev of infoPanel.eventosTecnicos; track $any(ev)._id) {
        <div class="st-evento">
          <div class="st-evento-top">
            <span class="st-estado">{{ $any(ev).estado }}</span>
            <div class="st-evento-acciones">
              <button
                irxBotonIcono
                tamano="compacto"
                tooltip="Editar"
                (click)="editarEvento($any(ev))"
              >
                <mat-icon>edit</mat-icon>
              </button>
              <button
                irxBotonIcono
                tamano="compacto"
                tooltip="Asignar técnico"
                (click)="asignarEvento($any(ev))"
              >
                <mat-icon>engineering</mat-icon>
              </button>
              <button
                irxBotonIcono
                tamano="compacto"
                tooltip="Atender"
                (click)="atenderEvento($any(ev))"
              >
                <mat-icon>troubleshoot</mat-icon>
              </button>
            </div>
          </div>
          @if ($any(ev).titulo) {
            <div class="st-titulo">{{ $any(ev).titulo }}</div>
          }
          @if ($any(ev).fechaCreacion) {
            <div class="st-row st-row-sm">
              <mat-icon class="material-symbols-outlined st-row-icon">
                calendar_today
              </mat-icon>
              <span>
                {{ $any(ev).fechaCreacion | date: 'dd/MM/yyyy HH:mm' }}
              </span>
            </div>
          }
          @if ($any(ev)._tecnicoNombre) {
            <div class="st-row st-row-sm">
              <mat-icon class="material-symbols-outlined st-row-icon">
                engineering
              </mat-icon>
              <span>{{ $any(ev)._tecnicoNombre }}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
